import { ILookupValue } from '../../model';

import { getApi } from './api';

const URL = '/city';

const getLookupValues = async (): Promise<ILookupValue[]> => {
  const api = await getApi();
  return api.get<ILookupValue[]>(`${URL}/lookup-values`).then((response) => response.data || []);
};

const getLookupValuesByCustomer = async (customerId: number): Promise<ILookupValue[]> => {
  const api = await getApi();
  return api.get<ILookupValue[]>(`${URL}/by-customer?id=${customerId}`).then((response) => response.data || []);
};

export const citiesService = {
  getLookupValues,
  getLookupValuesByCustomer,
};
